import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import sidebarNav from '../../configs/sidebarNav'; 
import './sidebar.css'; 

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [activeIndex, setActiveIndex] = useState(null); 
  const location = useLocation();  
  const isProvider = sessionStorage.getItem('provider_id') !== null;

  useEffect(() => {
    const path = location.pathname.split('/')[1]; 
    console.log('Current Path:', path);

    const index = sidebarNav.findIndex(item => item.section === path);

    setActiveIndex(index === -1 ? 0 : index);  
  }, [location]);  

  const closeSidebar = () => {
    document.body.classList.remove('sidebar-open');
  };

  const toggleSidebarHandler = () => {
    toggleSidebar();
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = isProvider ? '/provider-login' : '/login';
  };

  // Only show specific sidebar items if the user is a provider
  const filteredNav = sidebarNav.filter(nav => {
    if (isProvider) {
      // Show 'Provider Profile' for providers and other relevant links
      return nav.section === 'home' || 
             nav.section === 'bookingreport' || 
             nav.section === 'customersreport' || 
             nav.section === 'providerprofile'; // Include 'Provider Profile' for providers
    } else {
      // For admins (or non-providers), show everything except 'providerprofile'
      return nav.section !== 'providerprofile';
    }
  });
  return (
    <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <div className="sidebar__menu__item sidebar__menu__item--hamburger" onClick={toggleSidebarHandler}>
        <div className="sidebar__menu__item__icon">
          <i className={isOpen ? 'bx bx-chevron-left' : 'bx bx-menu-alt-right'}></i>
        </div>
      </div>
      <div className="sidebar__menu">
        {filteredNav.map((nav, index) => (
          <Link
            to={nav.link}
            key={index}
            className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}
            onClick={closeSidebar} 
          >
            <div className="sidebar__menu__item__icon">{nav.icon}</div>
            {isOpen && <div className="sidebar__menu__item__txt">{nav.text}</div>}
          </Link>
        ))}
        <div className="sidebar__menu__item" onClick={handleLogout}>
        <div className="sidebar__menu__item__icon">
            <i className="bx bx-log-out" style={{ color: 'red' }}></i> {/* Red color for the logout icon */}
          </div>
          <div className="sidebar__menu__item__txt">Logout</div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
